import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, MapPin, Users, Clock } from "lucide-react";

const CAT_LABELS = {
  warehouse: "WAREHOUSE",
  manufacturing: "MANUFACTURING",
  office: "OFFICE",
  apartment: "APARTMENT",
  hotel: "HOTEL",
  gym: "GYM",
  logistics: "TRUCKING / LOGISTICS",
  other: "OTHER",
};

export default function OpportunityCard({ opp, compact = false }) {
  return (
    <Link
      to={`/marketplace/${opp.id}`}
      data-testid={`opportunity-card-${opp.id}`}
      className="sb-card block overflow-hidden group hover:border-[#FFC107]/50 transition-colors"
    >
      <div className="relative sb-image-dim h-40 overflow-hidden">
        <img
          src={opp.image}
          alt={CAT_LABELS[opp.category]}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3 sb-pill sb-pill-gray backdrop-blur-md bg-black/60">
          {CAT_LABELS[opp.category]}
        </div>
        <div className="absolute top-3 right-3 sb-pill sb-pill-gold">
          Exclusive Opportunity
        </div>
        <div className="absolute bottom-2 left-3 text-[9.5px] uppercase tracking-[0.16em] text-white/55 font-semibold" style={{ textShadow: "0 1px 2px rgba(0,0,0,.8)" }}>
          Generic Category Image · Exact photos unlock after purchase
        </div>
      </div>
      <div className="p-5">
        <div className="flex items-center gap-2 text-[13px] text-[#A1A1AA]">
          <MapPin size={14} className="text-[#FFC107]" />
          {opp.city}, {opp.state} {opp.zip}
        </div>
        <div className="mt-3 grid grid-cols-2 gap-y-2 text-[12.5px] text-[#A1A1AA]">
          <div className="flex items-center gap-1.5">
            <Users size={13} /> ~{opp.employees} employees
          </div>
          <div className="flex items-center gap-1.5">
            <Clock size={13} /> {opp.shifts > 0 ? `${opp.shifts} shifts` : "Continuous"}
          </div>
          <div className="col-span-2 text-[12px] text-white/80">{opp.currentVending}</div>
          <div className="col-span-2 flex items-center gap-1.5 text-[#22C55E] text-[12px]">
            <CheckCircle2 size={13} /> Authorized manager verified
          </div>
          <div className="col-span-2 text-[12px] text-white/70">Interest: {opp.machines}</div>
        </div>
        {!compact && (
          <div className="mt-4">
            <div className="flex items-center justify-between text-[11px] text-[#A1A1AA] mb-1">
              <span>Verification Level</span>
              <span className="text-white font-bold">{opp.verification}/100</span>
            </div>
            <div className="sb-progress-track">
              <div className="sb-progress-fill" style={{ width: `${opp.verification}%` }} />
            </div>
          </div>
        )}
        <div className="mt-5 flex items-center justify-between">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-[#A1A1AA]">Price</div>
            <div className="text-2xl font-black text-white">${opp.price}</div>
          </div>
          <span className="sb-btn-primary text-[11px]" style={{ padding: "10px 14px" }}>
            View Opportunity
          </span>
        </div>
      </div>
    </Link>
  );
}
